module.exports = __webpack_public_path__ + "static/media/entrepeneur-assessment.0e31eb4c.png";